module.exports = __webpack_public_path__ + "static/Prof.GilsonKangPhDSOUTHKOREA-a2e90a06c6704328ee9063f76356a5da.jpg";